import { createContext } from 'react';

export const ResponsiveSiteContext = createContext(null);
ResponsiveSiteContext.displayName = 'ResponsiveSiteContext';
